/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5fdf9f18&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5fdf9f18&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdf9f18"]])

export default __exports__